"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
class SingleReportController {
    constructor(obj) {
        this.report = obj;
        this.soilTypes = [];
    }
    parsedMetadataProps(key) {
        let parsed = '';
        switch (this.report.tierra[key]) {
            case true:
                parsed = 'yes';
                break;
            case false:
                parsed = 'no';
                break;
            default:
                parsed = 'na';
        }
        return parsed;
    }
    booleanParser(v) {
        let parsed = '';
        if (typeof v !== 'string') {
            switch (v) {
                case true:
                    parsed = 'yes';
                    break;
                case false:
                    parsed = 'no';
                    break;
                default:
                    parsed = 'na';
            }
        }
        else {
            parsed = v;
        }
        return parsed;
    }
    async fetchData() {
        const data = { sample_code: this.report.c_muestra_wineseq };
        const resp = await axios_1.default.post('/samples/edit/get_info', data);
        this.report.tierra = resp.data.tierra;
        const tempSoilTypes = resp.data.soil_types.map((s, i) => {
            return {
                id: i,
                name: s.name,
            };
        });
        this.soilTypes = tempSoilTypes;
        /*         this.soilTypes.forEach((s, i) => {
            s.id = i;
        }) */
        const soilTypeSelected = this.soilTypes.filter((s) => (s.id = this.report.tierra.soil_type_id));
        if (soilTypeSelected.length > 0) {
            if (soilTypeSelected.length > 1) {
                this.report.tierra.soiltype = soilTypeSelected[1].name;
                this.report.tierra.soil_type_id = soilTypeSelected[1].id;
            }
        }
        else {
            this.report.tierra.soil_type_id = 0;
        }
    }
    async saveUpdatedReport(changedReport) {
        const data = {
            sample_code: changedReport.c_muestra_wineseq,
            name: changedReport.client_reference,
            date: changedReport.fecha_muestra.substring(0, 9),
            soil_type_id: changedReport.tierra.soil_type_id,
            plant_year: changedReport.tierra.plant_year,
            variety: changedReport.variety,
            density: changedReport.tierra.density,
            latitude: changedReport.tierra.latitud,
            longitude: changedReport.tierra.longitud,
            art_irrigation: this.booleanParser(changedReport.tierra.art_irrigation),
            org_practices: this.booleanParser(changedReport.tierra.org_practises),
            bio_methods: this.booleanParser(changedReport.tierra.uses_biodynamic_methods),
        };
        let response = { status: true, message: '', errors: [] };
        try {
            const resp = await axios_1.default.post('/samples/edit/save', data);
            return response;
        }
        catch (e) {
            response.status = false;
            response.message = e.response.data.message;
            if (e.response.data.errors) {
                const errorList = Object.entries(e.response.data.errors).map((field) => field[1][0]) ||
                    [];
                response.errors = errorList;
            }
            return response;
        }
    }
    async assignReportToParcel(reportID, parcelID) {
        const data = { sampleid: reportID, parcelid: parcelID };
        let response = {
            status: true,
            message: 'Parcel Successfully Assigned',
            errors: [''],
        };
        try {
            const resp = await axios_1.default.post('/parcel_reports/api_assign_sample_to_parcel', data);
            return response;
        }
        catch (e) {
            response.status = false;
            response.message = e.response.data.message;
            if (e.response.data.errors) {
                const errorList = Object.entries(e.response.data.errors).map((field) => field[1][0]) ||
                    [];
                response.errors = errorList;
            }
            return response;
        }
    }
}
exports.default = SingleReportController;
